import { put } from "redux-saga/effects";
import { globalActions } from "./slice";

export function* setLoadingState(isLoading: boolean, LoadingText?: string) {
  yield put({
    type: globalActions.setLoading.type,
    payload: { isLoading, LoadingText },
  });
}
